module.exports = __webpack_public_path__ + "static/playstore-fr-df3e03c633e12e45c8a0367bff9df745.png";